var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageRooms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 31C24.0604 31 31 24.0604 31 15.5C31 6.93959 24.0604 0 15.5 0C6.93959 0 0 6.93959 0 15.5C0 24.0604 6.93959 31 15.5 31ZM15 6C15 4.89543 14.1046 4 13 4C11.8954 4 11 4.89543 11 6V18V20H13H23C24.1046 20 25 19.1046 25 18C25 16.8954 24.1046 16 23 16H15V6Z",
    fill: "#ECECEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2334 31.9042C18.4295 31.9896 18.6467 32.0473 18.8836 32.0708L19.594 32.141C20.8511 32.2653 21.7808 33.368 21.6908 34.6281L21.6775 34.8136C21.5224 36.9856 24.1921 38.1371 25.6653 36.5336C26.5874 35.53 28.1814 35.5509 29.0859 36.5705C30.5413 38.2111 33.267 37.1347 33.1742 34.9436C33.1158 33.5637 34.2634 32.436 35.642 32.5185C37.8312 32.6495 38.973 29.9595 37.358 28.4757C36.341 27.5413 36.3551 25.9325 37.3882 25.016C39.0288 23.5606 37.9342 20.8511 35.743 20.9439C34.3631 21.0023 33.2354 19.8547 33.3179 18.4761C33.3809 17.4234 32.7916 16.6129 31.9978 16.2346C31.9993 16.3229 32.0001 16.4114 32.0001 16.5001C32.0001 18.5935 31.585 20.5901 30.8328 22.4119C32.3796 23.244 33.4311 24.8779 33.4311 26.7574C33.4311 29.4808 31.2234 31.6885 28.5 31.6885C26.8958 31.6885 25.4705 30.9224 24.57 29.7362C22.6853 30.8878 20.5354 31.6481 18.2334 31.9042ZM26.3357 28.4802C26.8425 29.1161 27.6237 29.5236 28.5 29.5236C30.0278 29.5236 31.2663 28.2851 31.2663 26.7574C31.2663 25.7268 30.7027 24.8279 29.867 24.352C28.9393 25.9278 27.7409 27.3252 26.3357 28.4802ZM19.066 21.0001H20.6865L19.6513 20.953C19.4454 20.9437 19.2498 20.9606 19.066 21.0001ZM22.3526 21.0001H24.0001C24.7386 21.0001 25.3836 20.5998 25.73 20.0044C24.7889 20.5223 23.7479 20.8523 22.6649 20.967L22.3526 21.0001Z",
    fill: "#ECECEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageRooms);
export default __webpack_public_path__ + "static/media/Manage Rooms.fa5206625a40bc2edf7f2ab35a4d8318.svg";
export { ForwardRef as ReactComponent };